export const MIN_CITATION_WORDS = 10;

export type CitationMetadata = {
  id: number;
  title: string;
  author: Array<{
    family?: string | null;
    given?: string | null;
    literal?: string;
  }>;
  issued?: number;
};

export function wordCount(text: string): number {
  return text
    .trim()
    .split(/\s+/u)
    .filter((word) => /[\p{L}\p{N}]/u.test(word)).length;
}

export function inlineCitation(metadata: CitationMetadata): string {
  const names = metadata.author
    .map((author) => author.family || author.literal || author.given)
    .filter(Boolean);
  let author = metadata.title;
  if (names.length === 1) author = names[0]!;
  if (names.length === 2) author = names.join(' & ');
  if (names.length > 2) author = `${names[0]} et al.`;
  return `(${author}, ${metadata.issued || 'n.d.'})`;
}
